var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowAltCircleRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.390625C19.1895 0.390625 24.6094 5.81055 24.6094 12.5C24.6094 19.1895 19.1895 24.6094 12.5 24.6094C5.81055 24.6094 0.390625 19.1895 0.390625 12.5C0.390625 5.81055 5.81055 0.390625 12.5 0.390625ZM6.83594 14.6484H12.5V18.1104C12.5 18.6328 13.1348 18.8965 13.501 18.5254L19.082 12.915C19.3115 12.6855 19.3115 12.3193 19.082 12.0898L13.501 6.47461C13.1299 6.10352 12.5 6.36719 12.5 6.88965V10.3516H6.83594C6.51367 10.3516 6.25 10.6152 6.25 10.9375V14.0625C6.25 14.3848 6.51367 14.6484 6.83594 14.6484Z",
    fill: "#14142B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowAltCircleRight);
export default __webpack_public_path__ + "static/media/arrow-alt-circle-right.16bc1f1883f4ac04c944874a1bc26aec.svg";
export { ForwardRef as ReactComponent };